<template>
  <el-dialog
    width="40%"
    class="dialog"
    custom-class="edit-old-valuation-dialog"
    title="修改旧机价值"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
  >
    <el-descriptions title="旧机" :column="2">
      <el-descriptions-item label="品牌">{{ formData.brand === "GREE" ? "格力" : "非格力" }}</el-descriptions-item>
      <el-descriptions-item label="品类">{{ formData.category }}</el-descriptions-item>
      <el-descriptions-item label="规格">{{ formData.specification + formData.model }}</el-descriptions-item>
    </el-descriptions>
    <el-form
      ref="ruleForm"
      label-position="right"
      :model="formData"
      label-width="140px"
    >
      <div class="el-descriptions__header el-descriptions__title">
        基础价格(含税)
      </div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="价格" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="price">
            <el-input
              v-model="formData.price"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'price')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="el-descriptions__header el-descriptions__title">
        扣款项(含税)
      </div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="1米铜管" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="meterCopperPrice">
            <el-input
              v-model="formData.meterCopperPrice"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'meterCopperPrice')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="1米铝管" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="meterAluminumPrice">
            <el-input
              v-model="formData.meterAluminumPrice"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'meterAluminumPrice')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="无-外机电机" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="exElectricalMachinery">
            <el-input
              v-model="formData.exElectricalMachinery"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'exElectricalMachinery')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="无-大阀门" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="bigValve">
            <el-input
              v-model="formData.bigValve"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'bigValve')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="无-内机电机" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="inElectricalMachinery">
            <el-input
              v-model="formData.inElectricalMachinery"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'inElectricalMachinery')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="无-小阀门" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="smallValve">
            <el-input
              v-model="formData.smallValve"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'smallValve')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="无-外机外罩" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="exCover">
            <el-input
              v-model="formData.exCover"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'exCover')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="无-外机风叶" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="exWindBlade">
            <el-input
              v-model="formData.exWindBlade"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'exWindBlade')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="无-外机顶板/底板" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="exBoard">
            <el-input
              v-model="formData.exBoard"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'exBoard')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="无-内机风叶" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="inWindBlade">
            <el-input
              v-model="formData.inWindBlade"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'inWindBlade')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="无-内机面板" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="internalPanel">
            <el-input
              v-model="formData.internalPanel"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'internalPanel')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="无-电源线" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="powerLine">
            <el-input
              v-model="formData.powerLine"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'powerLine')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="el-descriptions__header el-descriptions__title">
        税率
      </div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="税率（例如0.01）" :rules="[{ required: true, validator: validateAmount, trigger: 'blur' }]" prop="taxRate">
            <el-input
              v-model="formData.taxRate"
              placeholder="请输入"
              clearable
              @input="($event) => onInput($event, 'taxRate')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >保存</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { updateOldMachinePrice } from "@/api/oldValuation";

export default {
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      formData: {
        warehouseName: undefined,
        warehouseNo: undefined,
        wmsWarehouse: undefined, //1 是 0否
        financeWarehouseNo: undefined,
        contact: undefined,
        tel: undefined,
        address: undefined,
      },
      btnLoading: false,
    };
  },

  computed: {},
  watch: {
    dialogFormVisible: function(val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields();
      }
    }
  },
  methods: {
    validateAmount(rule, value, callback) {
      if (!value) {
          return callback(new Error('请输入'));
        }
        if (value < 0.01) {
          callback(new Error('必须大于等于0.01'));
        }else if (value > 999999.99) {
          callback(new Error('必须小于等于999999.99'));
        } else {
          callback();
        }
      // if (value === "") {
      //   callback(new Error("请输入金额"));
      // } else {
      //   if (value < 0) {

    },
    onInput(value, key) {
      console.log(value, key);
      this.formData[key] = ("" + value)
        .replace(/[^\d.]/g, "") //将非数字和点以外的字符替换成空
        .replace(/^\./g, "") //验证第一个字符是数字而不是点
        .replace(/\.{2,}/g, ".") //出现多个点时只保留第一个
        .replace(".", "$#$") // 1、将数字的点替换成复杂字符$#$
        .replace(/\./g, "") // 2、将字符串的点直接清掉
        .replace("$#$", ".") // 3、将复杂字符再转换回点
        .replace(/^(\-)*(\d+)\.(\d{2}).*$/, "$1$2.$3"); //只能输入两个小数
    },
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },

    // 打开弹框
    async openDialog(rowData) {
      this.formData = rowData;
      this.dialogFormVisible = true;
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.saveFormDataReq();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //新增or编辑
    async saveFormDataReq() {
      let { statusCode, message } = await updateOldMachinePrice(this.formData)
      if (statusCode == 200) {
        this.btnLoading = false;
        this.$message.success("编辑成功");
        this.$emit("opera-success");
        this.dialogFormVisible = false;
      } else {
        this.$message.error(message);
      }
      this.btnLoading = false;
    },

    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/editOldValuation.vue